import React, { useEffect, useRef } from 'react';
import { CircularProgress } from "@material-ui/core";

import ChatLoader from "../../utils/LoaderComponent/ChatLoader";
import { s360ConfigService } from "../Services/S360Config";

import Message from "./MessageBoxTypes/Message";

import "./ConversationStyleSheet.css";

const AlwaysScrollToBottom = () => {
  const elementRef = useRef();

  useEffect(() => {
    elementRef.current?.scrollIntoView()
  });

  return <div ref={elementRef} />;
};

function Conversation(props) {
  const messages = props.messages || [];
  const isFetchingMessages = props.isFetchingMessages || false;
  const isFetchingMessagesBelow = props.isFetchingMessagesBelow || false;
  const isLoaderEnabled = s360ConfigService.config.enableLoader || false;
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const customDesign = props.config?.customDesign ?? {};

  return (
    <div className={`s360-conversation${isFullScreen ? "-fs" : ""}`} id="s360-conversation-chat">
      {isFetchingMessages && (
        <div className="s360-message-container-activity-indicator"
          style={customDesign?.messageContainerActivityIndicator}>
          <CircularProgress color="inherit" size={20} />
        </div>
      )}
      {messages.map((message) => (
        <Message
          {...props}
          message={message}
          key={message.id}
          startNewConversation={props.startNewConversation}
          handleCustomerRetryMsg={props.handleCustomerRetryMsg}
        />
      ))}
      <AlwaysScrollToBottom />

      {!props.disableLoader && isLoaderEnabled && isFetchingMessagesBelow && (
        <div className="s360-message-container-activity-indicator" style={customDesign?.messageContainerActivityIndicator}>
          <ChatLoader/>
        </div>
      )}
    </div>
  );
}

export default Conversation;
